import React, { memo } from "react";
import { useMediaQuery } from 'react-responsive'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover'
import 'bootstrap/dist/css/bootstrap.min.css';

export const PopoverText = memo((props) => {
  const isMobileScreen = useMediaQuery({ query: '(max-width: 760px)'});
  const { textTitle, textBody } = props;

  const popover = (
    <Popover>
      <Popover.Header as="h3">{textTitle}</Popover.Header>
      <Popover.Body>{textBody}</Popover.Body>
    </Popover>
  );

  return (
    <>
      <OverlayTrigger trigger="click" rootClose placement={isMobileScreen ? 'top' : 'right'} overlay={popover}>
        <i className="fas fa-question-circle text-success" style={{cursor: 'pointer', marginLeft: '10px'}}></i>
      </OverlayTrigger>
    </>
  );
});